import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play, Youtube } from "lucide-react";
import api from "../lib/api";

const CHANNEL = "https://www.youtube.com/results?search_query=" + encodeURIComponent("Dr Ashley Froese");
const videoLink = (name) => "https://www.youtube.com/results?search_query=" + encodeURIComponent("Dr Ashley Froese " + name);

export default function MoreInfo() {
  const [products, setProducts] = useState([]);

  useEffect(() => { api.get("/products").then((r) => setProducts(r.data)).catch(() => {}); }, []);

  return (
    <section id="more-info" className="relative py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-10">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <div>
          <motion.p
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="text-[11px] tracking-[0.4em] uppercase text-[#00F0FF] mb-4 font-mono2"
          >
            // More Info
          </motion.p>
          <motion.h2
            initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
            className="font-display font-black text-3xl md:text-5xl uppercase tracking-tighter"
          >
            Watch &amp; <span className="text-[#00F0FF] neon-text">Learn</span>
          </motion.h2>
          <p className="text-xs text-slate-500 font-mono2 max-w-md mt-4">
            Educational videos on each peptide discussed by Dr Ashley Froese on YouTube.
          </p>
        </div>
        <a
          href={CHANNEL} target="_blank" rel="noopener noreferrer"
          className="inline-flex items-center gap-2 border border-[#FF003C]/50 text-[#FF003C] px-4 py-2.5 text-xs uppercase tracking-widest font-mono2 hover:bg-[#FF003C] hover:text-white transition-colors whitespace-nowrap"
          data-testid="moreinfo-channel"
        >
          <Youtube size={16} /> Dr Ashley Froese
        </a>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="moreinfo-grid">
        {products.map((p, i) => (
          <motion.a
            key={p.id}
            href={videoLink(p.name)} target="_blank" rel="noopener noreferrer"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-40px" }}
            transition={{ duration: 0.5, delay: (i % 3) * 0.06 }}
            className="group flex items-center gap-4 border border-white/10 hover:border-[#00F0FF]/50 bg-white/[0.02] p-4 transition-colors"
            data-testid={`moreinfo-${p.id}`}
          >
            <span className="flex items-center justify-center w-11 h-11 border border-[#00F0FF]/40 text-[#00F0FF] group-hover:bg-[#00F0FF] group-hover:text-black transition-colors shrink-0">
              <Play size={16} fill="currentColor" />
            </span>
            <div className="min-w-0">
              <p className="font-mono2 text-sm truncate">{p.name}</p>
              <p className="text-[10px] uppercase tracking-widest text-slate-500 font-mono2">Watch on YouTube →</p>
            </div>
          </motion.a>
        ))}
      </div>
    </section>
  );
}
